var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.1914 0 0 11.1914 0 25C0 38.8086 11.1914 50 25 50C38.8086 50 50 38.8086 50 25C50 11.1914 38.8086 0 25 0ZM18.0078 35.459H13.1348V19.8633H18.0078V35.459ZM15.4395 17.9102H15.4004C13.6328 17.9102 12.4902 16.7188 12.4902 15.2051C12.4902 13.6621 13.6719 12.5 15.4687 12.5C17.2656 12.5 18.3691 13.6621 18.4082 15.2051C18.418 16.709 17.2754 17.9102 15.4395 17.9102ZM37.5 35.459H31.9727V27.3926C31.9727 25.2832 31.1133 23.8379 29.209 23.8379C27.7539 23.8379 26.9434 24.8145 26.5723 25.752C26.4355 26.084 26.4551 26.5527 26.4551 27.0312V35.459H20.9766C20.9766 35.459 21.0449 21.1621 20.9766 19.8633H26.4551V22.3145C26.7773 21.2402 28.5254 19.7168 31.3184 19.7168C34.7852 19.7168 37.5 21.9629 37.5 26.7871V35.459Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinlogo);
export default __webpack_public_path__ + "static/media/linkedinlogo.94df61ae3300e8aa82c0b48a69638ea5.svg";
export { ForwardRef as ReactComponent };